import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { PANEL_FILTER_STATUS_OPTIONS } from "../../constants/panel-alerts.constants";
import {
  PanelAlertEntry,
  PanelCommandKey,
  PanelFeeder,
  PanelFilters
} from "../../interfaces/panel-alerts.interface";

/**
 * Listado de equipos del panel de testeos, con su barra de busqueda y el aviso
 * de cuanto hace que llego la ultima respuesta.
 */
@Component({
  selector: "app-panel-feeders",
  templateUrl: "./feeders.html",
  styleUrls: ["./feeders.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelFeedersComponent {
  /** Equipos que pasan los filtros, ya calculados por el padre. */
  @Input() feeders: PanelFeeder[] = [];
  @Input() filters: PanelFilters = { name: "", statusFeeders: "" };
  @Input() sentCommands: PanelCommandKey[] = [];
  /** Texto relativo de la ultima respuesta, ya formateado. */
  @Input() lastResponse = "";
  @Input() timezone = "";

  @Output() filtersChange = new EventEmitter<PanelFilters>();
  @Output() toggleCheck = new EventEmitter<number>();
  @Output() retry = new EventEmitter<{ feeder: PanelFeeder; alert: PanelAlertEntry }>();

  /** Opciones del desplegable de estado. */
  statusOptions = PANEL_FILTER_STATUS_OPTIONS;

  /**
   * Notifica un cambio en el texto de busqueda.
   * @param value Texto introducido.
   */
  onNameChange(value: string): void {
    this.filtersChange.emit({ ...this.filters, name: value });
  }

  /**
   * Notifica un cambio en el filtro de estado.
   * @param value Estado seleccionado.
   */
  onStatusChange(value: string): void {
    this.filtersChange.emit({
      ...this.filters,
      statusFeeders: value as PanelFilters["statusFeeders"]
    });
  }

  /**
   * Reenvia al padre el cambio de seleccion de un equipo.
   * @param id Identificador del alimentador.
   */
  onToggle(id: number): void {
    this.toggleCheck.emit(id);
  }

  /**
   * Reenvia al padre la peticion de reintento.
   * @param event Equipo y alerta a reintentar.
   */
  onRetry(event: { feeder: PanelFeeder; alert: PanelAlertEntry }): void {
    this.retry.emit(event);
  }

  /**
   * Identifica cada equipo para reutilizar su tarjeta al refiltrar.
   * @param index Posicion en la lista.
   * @param feeder Equipo de esa posicion.
   * @returns Identificador del alimentador.
   */
  trackByFeeder(index: number, feeder: PanelFeeder): number {
    return feeder.id;
  }
}
